import {handleFileSend, handleSend} from '../handleSend'

export const OrderApi = {
  //
  //   *订餐参数管理（50 *
  //
  // 订餐相关下拉框列表接口（50,0000）
  queryOrderDropDown (ListNo, CoditionList) {
    let data = {listNo: ListNo, coditionList: CoditionList}
    return handleSend(data, '50', '0000', '0', false)
  },
  // 订餐参数查询接口（50,0001）
  queryOrderParam (data, type = 0) {
    // data.pageNum = String(data.pageNum)
    // data.pageSize = String(data.pageSize)
    return handleSend(data, '50', '0001', String(type), 'message')
  },
  // 订餐参数修改接口（50,0002）
  handleOrderParam (data, type = 0) {
    return handleSend(data, '50', '0002', String(type), 'message')
  },
  // 菜品管理（51）
  // 新增/修改菜品类型接口（51,0001
  handleDishType (data, type = 0) {
    return handleSend(data, '51', '0001', String(type), 'message')
  },
  // 查询菜品类型接口（51,0002
  queryDishType (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '51', '0002', String(type), 'message')
  },
  // 删除菜品类型接口（51,0003
  delDishType (data, type = 0) {
    return handleSend(data, '51', '0003', String(type), 'message')
  },
  // 新增/修改菜品接口（51,1001
  handleDishInfo (data, type = 0) {
    return handleSend(data, '51', '1001', String(type), 'message')
  },
  // 查询菜品信息接口（51,1002
  queryDishInfo (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '51', '1002', String(type), 'message')
  },
  // 撤销菜品接口（51,1003
  delDishInfo (data, type = 0) {
    return handleSend(data, '51', '1003', String(type), 'message')
  },
  // 菜品图片批量上传接口（51,1004
  batchUploadDishPic (data, merchid) {
    let fd = new FormData() // FormData 对象
    data.forEach((file) => {
      fd.append('file', file.raw)
    })
    // fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', merchid)
    fd.append('AppCode', '51')
    fd.append('BizCode', '1004')
    return handleFileSend('/uploadFiles', '51', '1004', fd, 'Alert')
  },
  // 套餐管理（52）
  // 新增/修改套餐接口（52,0001
  handleMealInfo (data, type = 0) {
    return handleSend(data, '52', '0001', String(type), 'message')
  },
  // 查询套餐信息接口（52,0002）
  queryMealInfo (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '52', '0002', String(type), 'message')
  },
  // 撤销套餐接口（52,0003
  delMealInfo (data, type = 0) {
    return handleSend(data, '52', '0003', String(type), 'message')
  },
  // 套餐关联菜品接口（52,0004
  handleMealLinkDish (data, type = 0) {
    return handleSend(data, '52', '0004', String(type), 'message')
  },
  // 关联菜品查询接口（52,0005）
  queryMealLinkDish (data, type = 0) {
    return handleSend(data, '52', '0005', String(type), 'message')
  },
  // 套餐图片批量上传接口（52,0006
  batchUploadMealPic (data, merchid) {
    let fd = new FormData() // FormData 对象
    data.forEach((file) => {
      fd.append('file', file.raw)
    })
    // fd.append('file', data) // 文件对象
    fd.append('fileType', '0')
    fd.append('content', merchid)
    fd.append('AppCode', '52')
    fd.append('BizCode', '0006')
    return handleFileSend('/uploadFiles', '52', '0006', fd, 'Alert')
  },
  // 菜单管理（53）
  // 新增/修改菜单接口（53,0001
  handleFoodMenu (data, type = 0) {
    return handleSend(data, '53', '0001', String(type), 'message')
  },
  // 查询菜单信息接口（53,0002）
  queryFoodMenu (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '53', '0002', String(type), 'message')
  },
  // 撤销菜单接口（53,0003
  delFoodMenu (data, type = 0) {
    return handleSend(data, '53', '0003', String(type), 'message')
  },
  // 菜单关联套餐接口（53,0004
  handleMenuLinkMeal (data, type = 0) {
    return handleSend(data, '53', '0004', String(type), 'message')
  },
  // 关联套餐查询接口（53,0005）
  queryMenuLinkMeal (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '53', '0005', String(type), 'message')
  },
  // 菜单使用设置接口（53,0006
  handleFoodMenuUseSetting (data, type = 0) {
    return handleSend(data, '53', '0006', String(type), 'message')
  },
  // 修改菜单使用设置接口（53,0007）
  updateFoodMenuUseSetting (data, type = 0) {
    return handleSend(data, '53', '0007', String(type), 'message')
  },
  // 菜单使用查询接口（53,0008）
  queryFoodMenuUseSetting (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '53', '0008', String(type), 'message')
  },
  // 菜单使用设置删除接口（53,0009
  delFoodMenuUseSetting (data, type = 0) {
    return handleSend(data, '53', '0009', String(type), 'message')
  },
  // 菜单使用设置接口2（53,0010
  handleFoodMenuUseSetting2 (data, type = 0) {
    return handleSend(data, '53', '0010', String(type), 'message')
  },
  // 菜单使用查询接口2（53,0011）
  queryFoodMenuUseSetting2 (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '53', '0011', String(type), 'message')
  },
  //
  // 团餐管理（54）
  //
  // 新增/修改团餐接口（54,0001
  handleGroupOrder (data, type = 0) {
    return handleSend(data, '54', '0001', String(type), 'message')
  },
  // 查询团餐信息接口（54,0002）
  queryGroupOrder (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '54', '0002', String(type), 'message')
  },
  // 团餐删除接口（54,0003
  delGroupOrder (data, type = 0) {
    return handleSend(data, '54', '0003', String(type), 'message')
  },
  // 团餐统计查询接口（54,0004
  StatisticGroupOrder (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '54', '0004', String(type), 'message')
  },
  // 订餐明细查询接口（55,0001
  reportOfOrderDetail (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '55', '0001', String(type), 'message')
  },
  // 订餐统计查询接口（55,0002
  StatisticOrder (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '55', '0002', String(type), 'message')
  },
  // 取餐统计查询接口（55,0003
  StatisticTakeFood (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '55', '0003', String(type), 'message')
  },
  // 订餐退订退款接口（55,1001
  mealsUnsubscribe (data) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '55', '1001')
  },
  // 菜品备餐统计查询接口（55,0004
  FoodOrderStat (data, type = 0) {
    data.pageNum = String(data.pageNum)
    data.pageSize = String(data.pageSize)
    return handleSend(data, '55', '0004', String(type), 'message')
  }
}



// WEBPACK FOOTER //
// ./src/request/Order/order_api.js